import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css } from 'lit'


export const storeStockStyle = css`
  :host {
    display: flex;
    flex-flow: column;
    --csc-store-stock-gap: ${csSpacing.spacing07};
    gap: var(--csc-store-stock-gap);
  }

  .filter-row,
  csc-store-search-field {
    width: 100%;
  }
`
